<template>
  <div>
    <RRRTransactionHistory />
  </div>
</template>

<script>
import RRRTransactionHistory from '@/nfmp_components/RRRTransactionHistory.vue'
export default {
  components: {
    RRRTransactionHistory
  }
}
</script>